/**
 * Guest enrollment funnel uses `replace: true` after login, so the history stack
 * often has no meaningful "previous" entry. Header back must use logical parents.
 */
export const GUEST_ENROLLMENT_PATHS = {
  openEnrollment: "/guest-user/open-enrollment",
  welcome: "/guest-user/welcome",
  terms: "/guest-user/terms-of-use-and-condition",
  educational: "/guest-user/educational-content",
  paycheck: "/guest-user/paycheck",
  enrollment: "/guest-user/enrollment",
  esign: "/guest-user/esign",
  thankYou: "/guest-user/thank-you",
  updatedPaycheck: "/guest-user/updated-paycheck",
};

/** Default parent when opening educational content (after terms). */
export const GUEST_EDUCATIONAL_BACK_DEFAULT = GUEST_ENROLLMENT_PATHS.terms;

/** Persisted so returning from paycheck (push navigation without state) keeps the correct parent. */
export const GUEST_EDUCATIONAL_BACK_STORAGE_KEY = "guestEducationalBackTo";

export function normalizeGuestStepKey(step) {
  return String(step ?? "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");
}

export function guestEnrollmentPathFromStep(step) {
  switch (normalizeGuestStepKey(step)) {
    case "TERMS_CONDITIONS_VIEWED":
      return GUEST_ENROLLMENT_PATHS.terms;
    case "EDUCATIONAL_CONTENT_VIEWED":
      return GUEST_ENROLLMENT_PATHS.educational;
    case "PAYCHECK_ILLUSTRATION_VIEWED":
      return GUEST_ENROLLMENT_PATHS.paycheck;
    case "ENROLLMENT_ESIGN_COMPLETED":
      return GUEST_ENROLLMENT_PATHS.thankYou;
    case "WELCOME":
      return GUEST_ENROLLMENT_PATHS.welcome;
    case "ENROLLMENT_ESIGN_VIEWED":
      return GUEST_ENROLLMENT_PATHS.esign;
    case "ENROLLMENT_QUESTION_VIEWED":
      return GUEST_ENROLLMENT_PATHS.enrollment;
    case "ENROLLMENT_DECLINED":
      return GUEST_ENROLLMENT_PATHS.thankYou;
    case "PAYCHECK_ILLUSTRATION_UPDATED":
      return GUEST_ENROLLMENT_PATHS.updatedPaycheck;
    default:
      return GUEST_ENROLLMENT_PATHS.openEnrollment;
  }
}

/**
 * @param {"paycheck" | "enrollment" | "esign"} screen
 * @returns {string}
 */
export function guestEnrollmentBackPath(screen) {
  switch (screen) {
    case "paycheck":
      return GUEST_ENROLLMENT_PATHS.educational;
    case "enrollment":
      return GUEST_ENROLLMENT_PATHS.paycheck;
    case "esign":
      return GUEST_ENROLLMENT_PATHS.enrollment;
    default:
      return GUEST_ENROLLMENT_PATHS.openEnrollment;
  }
}
